!-- =========================================================================================
    File Name: Faq.vue
    Description: FAQ Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->

    <div class="vx-row">
      <!-- FAQ COL -->
      <div class="vx-col w-full mt-12 md:mt-0">
        <vs-collapse accordion type="margin" class="p-0">
          <vs-collapse-item
            v-for="(que, index) in filteredFaq"
            class="faq-bg rounded-lg"
            :class="{ 'mt-0': !index }"
            :key="que.id"
          >
            <div slot="header">
              <h5>{{ que.question }}</h5>
            </div>
            <p>{{ que.ans }}</p>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqSearchQuery: "",
      faqFilter: 1,
      faqs: [
        {
          id: 1,
          categoryId: 2,
          question: "What is the Flairboat Student Partner Program about?",
          ans:
            "Flairboat Student Partner Program is a full time marketing Internship program where you have to refer and promote flairboat application along with the activities and jobs for your campus.",
        },
        {
          id: 2,
          categoryId: 2,
          question: "Where can I find my Referral Id?",
          ans:
            "Your referral id is in the blue box on the dashboard. You can copy and share that id with your friends, seniors and colleagues to have them registered with your id",
        },
        {
          id: 3,
          categoryId: 5,
          question: "Where to enter Referral Id in mobile app?",
          ans:
            "In settings (In profile tab), there is a section for referral id. ",
        },
        {
          id: 4,
          categoryId: 2,
          question:
            "How can I track how many of my friends joined through my Referral Id?",
          ans:
            "You can check who has joined flairboat with your referral id on “Your Referrals” section on the dashboard. Anyone who uses your referral id their name will reflect on that section so that you can keep a track of it 😃.",
        },
        {
          id: 5,
          categoryId: 2,
          question:
            "Can I invite my friends for the Student Partner Program also?",
          ans:
            "Yes, you can also ask your friends to join student partner program, they would also be provided with all the perks.",
        },
        {
          id: 6,
          categoryId: 3,
          question:
            "What are milestones and how can I track my progress in the program?",
          ans:
            "Milestones are the small benchmarks or small targets to keep a track on the progress in the program. You can check progress of different milestones in Milestone Board over dashboard.",
        },
        {
          id: 7,
          categoryId: 3,
          question: "What is milestone 1?",
          ans:
            "In milestone 1 you have to invite 20 Friends or college colleagues to download Flairboat App from Play Store, Share relevant jobs and internship from app to your friends. On completion of this milestone you can download your Internship Certificate from milestone board.",
        },
        {
          id: 8,
          categoryId: 3,
          question: "What is milestone 2?",
          ans:
            "In milestone 2 you have to invite 50 Friends or college colleagues to download Flairboat App from Play Store, Share relevant jobs and internship from app to your friends. On completion of this milestone you can download your Letter of Recommendation from milestone board.",
        },
        {
          id: 9,
          categoryId: 3,
          question: "What is milestone 3?",
          ans:
            "In milestone 3 you have to invite 150 Friends or college colleagues to download Flairboat App from Play Store, Share relevant jobs and internship from app to your friends. On completion of this milestone you will receive a stipend of INR 2000.",
        },
        {
          id: 10,
          categoryId: 4,
          question: "What is milestone 4?",
          ans:
            "In milestone 4 you have to invite 300  Friends or college colleagues to download Flairboat App from Play Store, Share relevant jobs and internship from app to your friends. On completion of this milestone you will receive a stipend of INR 5000.",
        },
        {
          id: 11,
          categoryId: 4,
          question: "What is the duration of this Program?",
          ans: "Duration of this program is 1-3 Months. ",
        },
        {
          id: 12,
          categoryId: 5,
          question: "Is there any Stipend for Student Partner Program?",
          ans:
            "Yes, there is a variable stipend depending on how many and what milestones you have completed. ",
        },
        {
          id: 13,
          categoryId: 5,
          question: "How can I send Jobs and Internships to my Friends?",
          ans:
            "To share jobs and internships with your friends and colleagues you have to open flairboat mobile application and select a job, there is a share link on every jobs page on the top right  corner.",
        },
        {
          id: 14,
          categoryId: 5,
          question:
            "What are the Perks of joining Flairboat Student Partner Program?",
          ans:
            "There are different perks depending on the completion of different milestones like, Internship Certificate, Letter of Recommendation, INR 2000 and INR 5000, along with this we also help our student partners to find better career options.",
        },
        {
          id: 15,
          categoryId: 5,
          question:
            "Can I invite anyone to join the flairboat from my Referral Id?",
          ans:
            "Yes, you can invite anyone to join with your referral id, if they are a student.",
        },
      ],
    };
  },
  computed: {
    filteredFaq() {
      return this.faqs.filter((faq) => {
        if (this.faqFilter == 1)
          return (
            faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
            faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase())
          );
        else if (this.faqFilter == 2)
          return (
            faq.categoryId == 2 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 3)
          return (
            faq.categoryId == 3 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 4)
          return (
            faq.categoryId == 4 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 5)
          return (
            faq.categoryId == 5 &&
            (faq.question
              .toLowerCase()
              .includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
      });
    },
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss">
#faq-page {
  // .faq-jumbotron-content {
  //   background-image: url("../../assets/images/pages/faq.jpg");
  //   background-size: cover;
  // }

  .faq-bg {
    background-color: #fff;
  }
}
</style>
